import { Injectable } from '@angular/core';
import { ApiServiceBase } from './api.service.base';
import { Observable } from 'rxjs';
import { UserNotificationModel, UnreadCountResponse } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class UserNotificationService extends ApiServiceBase {
  public getUserNotifications(limit: number = 20, unreadOnly: boolean = false): Observable<UserNotificationModel[]> {
    return this.get('user-notifications', {
      params: {
        limit: limit.toString(),
        unreadOnly: unreadOnly.toString(),
      },
    });
  }

  public getUnreadCount(): Observable<UnreadCountResponse> {
    return this.get('user-notifications/unread-count');
  }

  public markAsRead(notificationId: string): Observable<void> {
    return this.put(`user-notifications/${notificationId}/mark-read`, {});
  }

  public markMultipleAsRead(notificationIds: string[]): Observable<void> {
    return this.put('user-notifications/mark-multiple-read', notificationIds);
  }

  public markAllAsRead(): Observable<void> {
    return this.put('user-notifications/mark-all-read', {});
  }

  public deleteNotification(notificationId: string): Observable<void> {
    return this.delete(`user-notifications/${notificationId}`);
  }

  public deleteMultipleNotifications(notificationIds: string[]): Observable<void> {
    return this.post('user-notifications/delete-multiple', notificationIds);
  }

  public deleteAllReadNotifications(): Observable<void> {
    return this.delete('user-notifications/delete-all-read');
  }
}
